const compatModules = {};import * as Mod1 from "./discourse/components/category-expert-post-indicator";
compatModules["discourse/components/category-expert-post-indicator"] = Mod1;

export * as discourse$components$category__expert__post__indicator$$__module from "./discourse/components/category-expert-post-indicator";
export {
default as discourse$components$category__expert__post__indicator$$default
} from "./discourse/components/category-expert-post-indicator";
import * as Mod2 from "./discourse/components/category-experts-approve-button";
compatModules["discourse/components/category-experts-approve-button"] = Mod2;

export * as discourse$components$category__experts__approve__button$$__module from "./discourse/components/category-experts-approve-button";
export {
default as discourse$components$category__experts__approve__button$$default,
setPostCategoryExpertAttributes as discourse$components$category__experts__approve__button$$setPostCategoryExpertAttributes
} from "./discourse/components/category-experts-approve-button";
import * as Mod3 from "./discourse/components/category-experts-form-kit-settings";
compatModules["discourse/components/category-experts-form-kit-settings"] = Mod3;

export * as discourse$components$category__experts__form__kit__settings$$__module from "./discourse/components/category-experts-form-kit-settings";
export {
default as discourse$components$category__experts__form__kit__settings$$default
} from "./discourse/components/category-experts-form-kit-settings";
import * as Mod4 from "./discourse/components/category-experts-settings";
compatModules["discourse/components/category-experts-settings"] = Mod4;

export * as discourse$components$category__experts__settings$$__module from "./discourse/components/category-experts-settings";
export {
default as discourse$components$category__experts__settings$$default
} from "./discourse/components/category-experts-settings";
import * as Mod5 from "./discourse/components/category-experts-unapprove-button";
compatModules["discourse/components/category-experts-unapprove-button"] = Mod5;

export * as discourse$components$category__experts__unapprove__button$$__module from "./discourse/components/category-experts-unapprove-button";
export {
default as discourse$components$category__experts__unapprove__button$$default
} from "./discourse/components/category-experts-unapprove-button";
import * as Mod6 from "./discourse/components/endorsement-button";
compatModules["discourse/components/endorsement-button"] = Mod6;

export * as discourse$components$endorsement__button$$__module from "./discourse/components/endorsement-button";
export {
default as discourse$components$endorsement__button$$default
} from "./discourse/components/endorsement-button";
import * as Mod7 from "./discourse/components/is-question-checkbox";
compatModules["discourse/components/is-question-checkbox"] = Mod7;

export * as discourse$components$is__question__checkbox$$__module from "./discourse/components/is-question-checkbox";
export {
default as discourse$components$is__question__checkbox$$default
} from "./discourse/components/is-question-checkbox";
import * as Mod8 from "./discourse/components/modal/endorse-user/endorsement-checkboxes";
compatModules["discourse/components/modal/endorse-user/endorsement-checkboxes"] = Mod8;

export * as discourse$components$modal$endorse__user$endorsement__checkboxes$$__module from "./discourse/components/modal/endorse-user/endorsement-checkboxes";
export {
default as discourse$components$modal$endorse__user$endorsement__checkboxes$$default
} from "./discourse/components/modal/endorse-user/endorsement-checkboxes";
import * as Mod9 from "./discourse/components/modal/endorse-user/index";
compatModules["discourse/components/modal/endorse-user/index"] = Mod9;

export * as discourse$components$modal$endorse__user$index$$__module from "./discourse/components/modal/endorse-user/index";
export {
default as discourse$components$modal$endorse__user$index$$default,
default as discourse$components$modal$endorse__user$$default
} from "./discourse/components/modal/endorse-user/index";
import * as Mod10 from "./discourse/components/modal/expert-group-chooser";
compatModules["discourse/components/modal/expert-group-chooser"] = Mod10;

export * as discourse$components$modal$expert__group__chooser$$__module from "./discourse/components/modal/expert-group-chooser";
export {
default as discourse$components$modal$expert__group__chooser$$default
} from "./discourse/components/modal/expert-group-chooser";
import * as Mod11 from "./discourse/components/reviewable/category-expert-suggestion";
compatModules["discourse/components/reviewable/category-expert-suggestion"] = Mod11;

export * as discourse$components$reviewable$category__expert__suggestion$$__module from "./discourse/components/reviewable/category-expert-suggestion";
export {
default as discourse$components$reviewable$category__expert__suggestion$$default
} from "./discourse/components/reviewable/category-expert-suggestion";
import * as Mod12 from "./discourse/connectors/above-review-filters/endorsed-username-to-filters.gjs";
compatModules["discourse/connectors/above-review-filters/endorsed-username-to-filters"] = Mod12;

export * as discourse$connectors$above__review__filters$endorsed__username__to__filters$$__module from "./discourse/connectors/above-review-filters/endorsed-username-to-filters.gjs";
export {
default as discourse$connectors$above__review__filters$endorsed__username__to__filters$$default
} from "./discourse/connectors/above-review-filters/endorsed-username-to-filters.gjs";
import * as Mod13 from "./discourse/connectors/advanced-search-options-below/category-experts-search-fields.gjs";
compatModules["discourse/connectors/advanced-search-options-below/category-experts-search-fields"] = Mod13;

export * as discourse$connectors$advanced__search__options__below$category__experts__search__fields$$__module from "./discourse/connectors/advanced-search-options-below/category-experts-search-fields.gjs";
export {
default as discourse$connectors$advanced__search__options__below$category__experts__search__fields$$default
} from "./discourse/connectors/advanced-search-options-below/category-experts-search-fields.gjs";
import * as Mod14 from "./discourse/connectors/category-custom-settings/category-experts-settings.gjs";
compatModules["discourse/connectors/category-custom-settings/category-experts-settings"] = Mod14;

export * as discourse$connectors$category__custom__settings$category__experts__settings$$__module from "./discourse/connectors/category-custom-settings/category-experts-settings.gjs";
export {
default as discourse$connectors$category__custom__settings$category__experts__settings$$default
} from "./discourse/connectors/category-custom-settings/category-experts-settings.gjs";
import * as Mod15 from "./discourse/connectors/composer-after-save-or-cancel/composer-is-question-checkbox.gjs";
compatModules["discourse/connectors/composer-after-save-or-cancel/composer-is-question-checkbox"] = Mod15;

export * as discourse$connectors$composer__after__save__or__cancel$composer__is__question__checkbox$$__module from "./discourse/connectors/composer-after-save-or-cancel/composer-is-question-checkbox.gjs";
export {
default as discourse$connectors$composer__after__save__or__cancel$composer__is__question__checkbox$$default
} from "./discourse/connectors/composer-after-save-or-cancel/composer-is-question-checkbox.gjs";
import * as Mod16 from "./discourse/connectors/composer-fields/is-category-expert-question.gjs";
compatModules["discourse/connectors/composer-fields/is-category-expert-question"] = Mod16;

export * as discourse$connectors$composer__fields$is__category__expert__question$$__module from "./discourse/connectors/composer-fields/is-category-expert-question.gjs";
export {
default as discourse$connectors$composer__fields$is__category__expert__question$$default
} from "./discourse/connectors/composer-fields/is-category-expert-question.gjs";
import * as Mod17 from "./discourse/connectors/topic-category/is-question-indicator.gjs";
compatModules["discourse/connectors/topic-category/is-question-indicator"] = Mod17;

export * as discourse$connectors$topic__category$is__question__indicator$$__module from "./discourse/connectors/topic-category/is-question-indicator.gjs";
export {
default as discourse$connectors$topic__category$is__question__indicator$$default
} from "./discourse/connectors/topic-category/is-question-indicator.gjs";
import * as Mod18 from "./discourse/connectors/topic-list-after-title/category-experts-indicator.gjs";
compatModules["discourse/connectors/topic-list-after-title/category-experts-indicator"] = Mod18;

export * as discourse$connectors$topic__list__after__title$category__experts__indicator$$__module from "./discourse/connectors/topic-list-after-title/category-experts-indicator.gjs";
export {
default as discourse$connectors$topic__list__after__title$category__experts__indicator$$default
} from "./discourse/connectors/topic-list-after-title/category-experts-indicator.gjs";
import * as Mod19 from "./discourse/connectors/user-card-additional-buttons/endorsement-button.gjs";
compatModules["discourse/connectors/user-card-additional-buttons/endorsement-button"] = Mod19;

export * as discourse$connectors$user__card__additional__buttons$endorsement__button$$__module from "./discourse/connectors/user-card-additional-buttons/endorsement-button.gjs";
export {
default as discourse$connectors$user__card__additional__buttons$endorsement__button$$default
} from "./discourse/connectors/user-card-additional-buttons/endorsement-button.gjs";
import * as Mod20 from "./discourse/connectors/user-profile-controls/endorsement-button.gjs";
compatModules["discourse/connectors/user-profile-controls/endorsement-button"] = Mod20;

export * as discourse$connectors$user__profile__controls$endorsement__button$$__module from "./discourse/connectors/user-profile-controls/endorsement-button.gjs";
export {
default as discourse$connectors$user__profile__controls$endorsement__button$$default
} from "./discourse/connectors/user-profile-controls/endorsement-button.gjs";
import * as Mod21 from "./discourse/helpers/category-expert-question-indicator";
compatModules["discourse/helpers/category-expert-question-indicator"] = Mod21;

export * as discourse$helpers$category__expert__question__indicator$$__module from "./discourse/helpers/category-expert-question-indicator";
export {
categoryExpertQuestionIndicator as discourse$helpers$category__expert__question__indicator$$categoryExpertQuestionIndicator,
default as discourse$helpers$category__expert__question__indicator$$default
} from "./discourse/helpers/category-expert-question-indicator";
import * as Mod22 from "./discourse/initializers/category-experts-post-decorator";
compatModules["discourse/initializers/category-experts-post-decorator"] = Mod22;

export * as discourse$initializers$category__experts__post__decorator$$__module from "./discourse/initializers/category-experts-post-decorator";
export {
default as discourse$initializers$category__experts__post__decorator$$default
} from "./discourse/initializers/category-experts-post-decorator";
import * as Mod23 from "./discourse/initializers/category-experts-search";
compatModules["discourse/initializers/category-experts-search"] = Mod23;

export * as discourse$initializers$category__experts__search$$__module from "./discourse/initializers/category-experts-search";
export {
default as discourse$initializers$category__experts__search$$default
} from "./discourse/initializers/category-experts-search";
import * as Mod24 from "./discourse/pre-initializers/extend-for-category-experts";
compatModules["discourse/pre-initializers/extend-for-category-experts"] = Mod24;

export * as discourse$pre__initializers$extend__for__category__experts$$__module from "./discourse/pre-initializers/extend-for-category-experts";
export {
default as discourse$pre__initializers$extend__for__category__experts$$default
} from "./discourse/pre-initializers/extend-for-category-experts";
export default compatModules;
